<template>
  <card>
    <list
      v-if="$store.state.user.sections['transfers']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setImport="false"
      :setLink="setLink"
      :staticFilters="staticFilters"
      :openItem="true"
      :fields="fields"
      :filters="filters"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :dateFilter="dateFilter"
      :projectInfo="5"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  created() {
    if (this.$store.state.user.is_root) {
      this.filters.push({
        key: "shop",
        title: "Фильтр по торговым точкам",
        titleKey: "shop_filter",
        field_key: "shop",
        selectKey: "name",
      });
    }
  },
  data() {
    return {
      filters: [
        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "user_filter",
          field_key: "user",
          selectKey: "name",
        },
      ],
      staticFilters: [
        {
          title: "Статус",
          key: "status",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "new",
              title: "В процессе",
            },
            {
              id: "sent",
              title: "Оформлено",
            },
            {
              id: "done",
              title: "В пути",
            },
            {
              id: "received",
              title: "Получено",
            },
            {
              id: "cancel",
              title: "Отменен",
            },
          ],
        },
      ],
      params: {},
      val: [],
      modalCreate: "role",
      fields: [
        {
          label: "Номер телефона отправителя",
          key: "sender_phone",

          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          label: "Полное имя отправителя",
          key: "sender_name",
          type: "field",
        },
        {
          label: "Услуга",
          labelKey: "service",
          key: "service",
          type: "select-full",
          modal: "service",
          fieldKey: "id",
          selectKey: "name",
          params: { type_object: "3" },
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_transfer",
      itemLink: "transfers",
      setLink: "transfers",
      columns: [
        {
          detail: true,
        },
        {
          key: "id",
          title: "ID",
        },
        {
          key: "display_status",
          title: "Статус",
        },
        {
          key: "name",
          title: "Код посылки (партнер)",
        },
        {
          key: "service",
          object: "name",
          title: "Сервис",
          disableLink: true,
          full: true,
        },
        {
          key: "shop",
          object: "name",
          title: "Торговая точка",
          disableLink: true,
          full: true,
        },
        {
          key: "user",
          object: "name",
          title: "Оператор",
          disableLink: true,
          full: true,
        },
        {
          key: "sent_at",
          title: "Дата отправки",
          dateTimeFormat: true,
          full: true,
        },
        {
          key: "created_at",
          title: "Дата создания",
          dateTimeFormat: true,
          full: true,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>